import { ReactNode } from 'react';

export enum SnackbarType {
  DEFAULT = 'default',
  WARNING = 'warning',
  ERROR = 'error',
  SUCCESS = 'success',
  INFO = 'info'
}

export interface SnackbarProps {
  message: string;
  open: boolean;
  type?: SnackbarType;
  onClose: () => void;
  closeButtonDuration?: number;
}

export interface UseSnackbarReturn {
  shouldRender: boolean;
  showCloseButton: boolean;
} 